<rt-infobox [isDismissible]="false" type="warning" iconName="warning">
  <div layout layout-space-between>
    <span
      [innerHTML]="'app.offers.switch_editors_infobox.message' | translate"
      padding-right-medium
    >
    </span>
    <rt-button variant="plain" size="small" (click)="onSwitchEditorsClick()">
      {{ 'app.offers.switch_editors_infobox.button_label' | translate }}
    </rt-button>
  </div>
</rt-infobox>
